class TextOffersWr {
    constructor() {
        document.querySelectorAll('.card-button').forEach((el) => {
            el.addEventListener('click', function(ev) {
                var pagePath = window.location.pathname;
                sessionStorage.setItem("currentPagePath", pagePath);
                //"redeemComplete" Event Activation Point - Push Adobe Digital Data onclick of Redeem Now button link on Redeem More Page.
                if(ev.target.innerText.toUpperCase() == 'REDEEM NOW') {
                    window.AdobeWebSdk && window.AdobeWebSdk.onClickRewardRedeemBtnRewardsPage(ev.target);
                }
            });
        });
    }
}

export default new TextOffersWr();
